import { render, staticRenderFns } from "./SectionProgramPerson.vue?vue&type=template&id=27d796ba&scoped=true&"
import script from "./SectionProgramPerson.vue?vue&type=script&lang=js&"
export * from "./SectionProgramPerson.vue?vue&type=script&lang=js&"
import style0 from "./SectionProgramPerson.vue?vue&type=style&index=0&id=27d796ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d796ba",
  null
  
)

export default component.exports